export default "__VITE_ASSET__B6E$qJdB__"